// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ArticleResourceViewModel from '../../../../viewModel/resource/ArticleResourceViewModel';
import BasketItemResourceViewModel from '../../../../viewModel/resource/BasketItemResourceViewModel';
import BasketItemResourceDTO from '../../dto/resource/BasketItemResourceDTO';

export default abstract class BasketItemResourceModel extends BaseModel<BasketItemResourceDTO> {
  /**
  * @type {int32}
  */
  get count() { return this.dto.count; }
  set count(value) { this.dto.count = value; }
  /**
  */
  get article() { return this.getObjectModel(() => this.dto.article, ArticleResourceViewModel)!; }
  set article(value) { this.setObjectModel(() => this.dto.article, value); }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.count);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.count = value;
  }
}
